<template>
  <div class="box-layout">
    <template v-if="this.message.type === 'text'">
      <div class="flex">
        <img src="/static/img/assets/welcome/TypeText.svg" />
        <typography h6 :label="$t('ข้อความ')" :medium="true"></typography>
      </div>
      <div
        v-if="broadcastType === 'draft'"
        class="flex"
        style="justify-content: flex-end; gap: 0px"
      >
        <img
          class="EditIcon"
          @click="openModal(message.type)"
          src="/static/img/assets/welcome/edit.svg"
        />
        <img
          class="EditIcon"
          @click="toggleDeleteMessage"
          src="/static/img/assets/welcome/delete.svg"
        />
        <img class="DragIcon handle" src="/static/img/assets/welcome/Drag.svg" />
      </div>
      <modal-notify v-if="modalText" :isFixed="false" modalWidth="380px">
        <div slot="header">
          <div
            style="display: flex; flex-direction: row; justify-content: space-between; width: 100%"
          >
            <typography h2 :label="$t('แก้ไขข้อความ')" :bold="true"></typography>
            <img
              src="/static/img/assets/welcome/X.svg"
              class="close-icon"
              @click="cancelModal(message.type)"
            />
          </div>
        </div>
        <div slot="body">
          <div class="hr-color" style="margin-top: 16px"></div>
          <div style="position: relative">
            <textarea
              :value="textTitle"
              @input=";(textTitle = $event.target.value), isValid()"
              style="min-height: 80px; width: 330px; padding: 14px"
              class="text-area-focus"
              v-validate="'required'"
              name="ข้อความ"
              maxlength="2000"
              rows="4"
            >
            </textarea>
            <div
              style="
                display: flex;
                position: absolute;
                justify-content: flex-end;
                margin-right: 12px;
                margin-bottom: 8px;
                color: #bdbdbd;
                font-weight: 500;
                font-size: 12px;
                right: 0;
                bottom: 0;
              "
            >
              {{ textTitle.length }}/2000
            </div>
          </div>
          <span class="text-error" v-if="errors.has('ข้อความ')">
            {{ errors.first('ข้อความ') }}
          </span>

          <div
            style="display: flex; flex-direction: row; margin-top: 16px; flex-wrap: wrap; gap: 6px"
          >
            <div
              class="tag-box"
              v-for="(item, index) in this.textRecommend"
              :key="'normal_question_' + index"
            >
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  gap: 4px;
                  align-items: center;
                  justify-content: center;
                "
                @click="textAddRecommend(item.value)"
              >
                <typography h5 color="color-darkBlue" :label="item.title" />
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="hr-color" style="margin-top: 16px"></div>
          <div class="btn-footer">
            <Button
              width="142px"
              outline
              :label="$t('cancel')"
              @click="cancelModal(message.type)"
            />
            <Button width="142px" depressed :label="$t('Save')" @click="addMessage(message.type)" />
          </div>
        </div>
      </modal-notify>
    </template>

    <template v-if="this.message.type === 'button'">
      <div class="flex">
        <img src="/static/img/assets/welcome/TypeButton.svg" />
        <typography h6 :label="$t('ปุ่มกด')" :medium="true"></typography>
      </div>
      <div
        v-if="broadcastType === 'draft'"
        class="flex"
        style="justify-content: flex-end; gap: 0px"
      >
        <img
          class="EditIcon"
          @click="openModal(message.type)"
          src="/static/img/assets/welcome/edit.svg"
        />
        <img
          class="EditIcon"
          @click="toggleDeleteMessage"
          src="/static/img/assets/welcome/delete.svg"
        />
        <img class="DragIcon handle" src="/static/img/assets/welcome/Drag.svg" />
      </div>
      <modal-notify v-if="modalButton" :isFixed="true" modalWidth="400px">
        <div slot="header">
          <div
            style="display: flex; flex-direction: row; justify-content: space-between; width: 100%"
          >
            <typography h2 :label="$t('แก้ไขปุ่มกด')" :bold="true"></typography>
            <img
              src="/static/img/assets/welcome/X.svg"
              class="close-icon"
              @click="cancelModal(message.type)"
            />
          </div>
        </div>

        <div slot="body">
          <div style="display: flex; flex-direction: column; align-items: center; margin-top: 20px">
            <div class="input-border">
              <input
                v-model="buttonTitle"
                maxlength="20"
                style="height: 40px; width: 300px; margin-left: 14px; margin-bottom: 0px"
                class="input-focus"
                placeholder="กรุณาใส่ข้อความ"
              />

              <div style="display: flex; justify-content: flex-end; margin-right: 12px">
                <typography
                  h7
                  medium
                  :label="`${buttonTitle.length}/20`"
                  color="color-lightMediumGrey"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 4px;
                margin-top: 16px;
              "
            >
              <template v-for="(data, index) in this.buttonButton">
                <div class="button-editButton">
                  <template v-if="buttonEditButton[index]">
                    <input
                      v-model="data.title"
                      class="input-focus"
                      style="color: #fff; font-weight: 700; font-size: 16px; margin-left: 0"
                    />
                    <img
                      src="/static/img/assets/welcome/correct-white.svg"
                      style="width: 20px; height: 20px"
                      @click="buttonChangeEditButton(index)"
                    />
                  </template>
                  <template v-else>
                    <div style="width: 100%">
                      <typography h5 :label="data.title" bold color="color-white" />
                    </div>
                    <img
                      src="/static/img/assets/welcome/pencil-white.svg"
                      style="width: 20px; height: 20px"
                      @click="buttonChangeEditButton(index)"
                    />
                  </template>
                  <img
                    src="/static/img/assets/welcome/bin-white.svg"
                    style="width: 20px; height: 20px"
                    @click="buttonDeleteButton(index)"
                  />
                </div>
              </template>
              <template v-if="buttonButton.length < 3">
                <div class="button-addButton" @click="buttonAddButton">
                  <img
                    src="/static/img/assets/welcome/plus-gray.svg"
                    style="width: 20px; height: 20px"
                  />
                  <div style="color: #bdbdbd; font-weight: 700; font-size: 16px">เพิ่มปุ่มกด</div>
                </div>
              </template>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 4px;
                margin-top: 16px;
                width: 100%;
              "
            >
              <div
                style="display: flex; flex-direction: row; justify-content: flex-start; width: 100%"
              >
                <div style="font-weight: 600; font-size: 16px; color: #2c2c2c">ตั้งค่าปุ่มกด</div>
              </div>
              <template v-for="(data, index) in this.buttonButton">
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    margin-top: 8px;
                    width: 100%;
                  "
                >
                  <div class="button-settingButtonTop">
                    {{ data.title }}
                  </div>
                  <div class="button-settingButtonBotton">
                    <div class="broadcast-button-module">
                      <v-select
                        v-model="data.type"
                        :items="buttonType"
                        item-text="name"
                        item-value="type"
                        hide-details
                        dense
                        outline
                        append-icon="mdi-chevron-down"
                      >
                        <template slot="selection" slot-scope="data">
                          <div style="display: flex; align-items: center; width: 100%">
                            <v-flex xs2>
                              <img :src="`/static/img/${data.item.icon}`" style="width: 20px" />
                            </v-flex>
                            <v-flex xs10>
                              <typography h5 color="color-mediumBlue" :label="data.item.name" />
                            </v-flex>
                          </div>
                        </template>
                        <template slot="item" slot-scope="data">
                          <v-flex xs2>
                            <img :src="`/static/img/${data.item.icon}`" style="width: 20px" />
                          </v-flex>
                          <v-flex xs10>
                            <typography h5 color="color-mediumBlue" :label="data.item.name" />
                          </v-flex>
                        </template>
                      </v-select>
                    </div>
                    <template v-if="data.type === 'web_url'">
                      <div style="font-weight: 500; font-size: 14px; color: #818181">
                        *หากลูกค้ากดปุ่มนี้ บอทจะพาลูกค้าไปสู่ลิ้งค์นี้
                      </div>
                      <div style="width: 100%">
                        <div style="color: #2c2c2c; font-weight: 600; font-size: 16px">ลิ้งค์</div>

                        <div class="input-border">
                          <input
                            v-model="data.url"
                            class="input-focus"
                            placeholder="http://www.example.com"
                          />
                        </div>
                      </div>
                    </template>
                    <template v-if="data.type === 'postback'">
                      <div style="font-weight: 500; font-size: 14px; color: #818181">
                        *หากลูกค้ากดปุ่มนี้ บอทจะตอบกลับลูกค้า (คุณสามารถแก้ไขคำตอบในหน้า
                        conversation)
                      </div>
                      <div>
                        <div style="color: #2c2c2c; font-weight: 600; font-size: 16px">Action</div>
                        <div class="input-border">
                          <input v-model="data.payload" class="input-focus" />
                        </div>
                      </div>
                    </template>
                    <template v-if="data.type === 'phone_number'">
                      <div style="font-weight: 500; font-size: 14px; color: #818181">
                        *หากลูกค้ากดปุ่มนี้ บอทจะโทรออกอัตโนมัติตามเบอร์ที่กรอกไว้
                        (ฟังก์ชันนี้ใช้ได้เมื่อลูกค้าใช้มือถือในการเชื่อมต่อเท่านั้น)
                      </div>
                      <div>
                        <div style="color: #2c2c2c; font-weight: 600; font-size: 16px">
                          เบอร์โทร
                        </div>
                        <div class="input-border">
                          <input
                            v-model="data.payload"
                            class="input-focus"
                            placeholder="+66000000000"
                          />
                        </div>
                      </div>
                    </template>
                    <template v-if="data.type === 'broadcast'">
                      <div class="type-radio">
                        <v-radio-group v-model="data.payload" row>
                          <v-radio
                            label="สมัครรับข่าวสาร"
                            value="subscribeBroadcast"
                            color="rgba(12, 47, 83, 1)"
                          ></v-radio>
                          <v-radio
                            label="ยกเลิกรับข่าวสาร"
                            value="unsubscribeBroadcast"
                            color="rgba(12, 47, 83, 1)"
                          ></v-radio>
                        </v-radio-group>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="hr-color" style="margin-top: 16px"></div>
          <div class="btn-footer">
            <Button
              width="142px"
              outline
              :label="$t('cancel')"
              @click="cancelModal(message.type)"
            />
            <Button width="142px" depressed :label="$t('Save')" @click="addMessage(message.type)" />
          </div>
        </div>
      </modal-notify>
    </template>

    <template v-if="this.message.type === 'image'">
      <div class="flex">
        <img src="/static/img/assets/welcome/TypeImage.svg" />
        <typography h6 :label="$t('รูปภาพ')" :medium="true"></typography>
      </div>
      <div
        v-if="broadcastType === 'draft'"
        class="flex"
        style="justify-content: flex-end; gap: 0px"
      >
        <img
          class="EditIcon"
          @click="openModal(message.type)"
          src="/static/img/assets/welcome/edit.svg"
        />
        <img
          class="EditIcon"
          @click="toggleDeleteMessage"
          src="/static/img/assets/welcome/delete.svg"
        />
        <img class="DragIcon handle" src="/static/img/assets/welcome/Drag.svg" />
      </div>
      <modal-notify v-if="modalImage" :isFixed="false" modalWidth="400px">
        <div slot="header">
          <div
            style="display: flex; flex-direction: row; justify-content: space-between; width: 100%"
          >
            <typography h2 :label="$t('แก้ไขรูปภาพ')" :bold="true"></typography>
            <img
              src="/static/img/assets/welcome/X.svg"
              class="close-icon"
              @click="cancelModal(message.type)"
            />
          </div>
        </div>

        <div slot="body">
          <div
            :ref="'answer_' + (intent_index - 1) + '_' + intent_index"
            class="message"
            style="
              float: left;
              position: relative;
              border-radius: 12px;
              height: 246px;
              width: 100%;
              overflow-wrap: break-word;
              min-height: 22px;
              min-width: 14px;
              line-height: 15.36px;
              overflow: hidden;
              margin-top: 40px;
            "
          >
            <uploadfile
              ref="answer"
              v-model="image_url"
              :height="246"
              data-vv-as="Image"
              :data-vv-name="'answer_' + (intent_index - 1) + '_image_' + intent_index"
              v-validate
            ></uploadfile>
          </div>
          <div class="clearfix"></div>
        </div>
        <div slot="footer">
          <div class="hr-color" style="margin-top: 16px"></div>
          <div class="btn-footer">
            <Button
              width="142px"
              outline
              :label="$t('cancel')"
              @click="cancelModal(message.type)"
            />
            <Button width="142px" depressed :label="$t('Save')" @click="addMessage(message.type)" />
          </div>
        </div>
      </modal-notify>
    </template>

    <template v-if="this.message.type === 'video'">
      <div class="flex">
        <img src="/static/img/assets/welcome/TypeVideo.svg" />
        <typography h6 :label="$t('วีดิโอ')" :medium="true"></typography>
      </div>
      <div
        v-if="broadcastType === 'draft'"
        class="flex"
        style="justify-content: flex-end; gap: 0px"
      >
        <img
          class="EditIcon"
          @click="openModal(message.type)"
          src="/static/img/assets/welcome/edit.svg"
        />
        <img
          class="EditIcon"
          @click="toggleDeleteMessage"
          src="/static/img/assets/welcome/delete.svg"
        />
        <img class="DragIcon handle" src="/static/img/assets/welcome/Drag.svg" />
      </div>
      <modal-notify v-if="modalVideo" :isFixed="false" modalWidth="400px">
        <div slot="header">
          <div
            style="display: flex; flex-direction: row; justify-content: space-between; width: 100%"
          >
            <typography h2 :label="$t('แก้ไขวีดิโอ')" :bold="true"></typography>
            <img
              src="/static/img/assets/welcome/X.svg"
              class="close-icon"
              @click="cancelModal(message.type)"
            />
          </div>
        </div>

        <div slot="body">
          <div style="display: flex; flex-direction: column; justify-content: flex-start">
            <v-radio-group v-model="videoType" row>
              <v-radio
                v-for="item in this.videoCheckType"
                :key="item.name"
                :label="`${item.name}`"
                :value="item.type"
                color="rgba(12, 47, 83, 1)"
              ></v-radio>
            </v-radio-group>
            <template v-if="videoType === 'upload'">
              <div
                :ref="'answer_' + (intent_index - 1) + '_' + intent_index"
                class="message"
                style="
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  height: 246px;
                  width: 328px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                "
              >
                <uploadVideo v-model="upload_url"> </uploadVideo>
              </div>
            </template>
            <template v-if="videoType === 'link_url'">
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  gap: 4px;
                  border: 1px solid #0c2f53;
                  border-radius: 10px;
                  height: 40px;
                  width: 330px;
                "
              >
                <input
                  v-model="video_url"
                  style="height: 40px; width: 300px; margin-left: 14px; margin-bottom: 0px"
                  class="input-focus"
                  placeholder="กรุณาใส่ข้อความ"
                />
              </div>
            </template>
            <div class="clearfix"></div>
          </div>
        </div>

        <div slot="footer">
          <div class="hr-color" style="margin-top: 16px"></div>
          <div class="btn-footer">
            <Button
              width="142px"
              outline
              :label="$t('cancel')"
              @click="cancelModal(message.type)"
            />
            <Button width="142px" depressed :label="$t('Save')" @click="addMessage(message.type)" />
          </div>
        </div>
      </modal-notify>
    </template>

    <template v-if="this.message.type === 'generic'">
      <div class="flex">
        <img src="/static/img/assets/welcome/TypeListMenu.svg" />
        <typography h6 :label="$t('ลิสต์เมนู')" :medium="true"></typography>
      </div>
      <div
        v-if="broadcastType === 'draft'"
        class="flex"
        style="justify-content: flex-end; gap: 0px"
      >
        <img
          class="EditIcon"
          @click="openModal(message.type)"
          src="/static/img/assets/welcome/edit.svg"
        />
        <img
          class="EditIcon"
          @click="toggleDeleteMessage"
          src="/static/img/assets/welcome/delete.svg"
        />
        <img class="DragIcon handle" src="/static/img/assets/welcome/Drag.svg" />
      </div>
      <modal-notify v-if="modalGeneric" :isFixed="true" modalWidth="400px">
        <div slot="header">
          <div
            style="display: flex; flex-direction: row; justify-content: space-between; width: 100%"
          >
            <typography h2 :label="$t('แก้ไขลิสต์เมนู')" :bold="true"></typography>
            <img
              src="/static/img/assets/welcome/X.svg"
              class="close-icon"
              @click="cancelModal(message.type)"
            />
          </div>
        </div>
        <div slot="body">
          <div style="width: 100%; margin-top: 20px">
            <div style="width: 100%">
              <carousel
                :navigationEnabled="true"
                :paginationEnabled="false"
                :perPage="1"
                v-model="genericButtonIndex"
                ref="carousel"
                class="carousel-container"
                :navigation-next-label="nextLabel"
                :navigationPrevLabel="prevLabel"
              >
                <slide
                  v-for="(data, index) in this.genericData"
                  :key="`card-${index}`"
                  class="carousel-card"
                >
                  <div style="position: relative">
                    <img
                      v-if="genericData.length > 1"
                      src="/static/img/DeleteListMenu.png"
                      style="
                        width: 35px;
                        height: 35px;
                        position: absolute;
                        z-index: 10;
                        left: -10px;
                        cursor:pointer;
                      "
                      @click="genericDeleteContent(index)"
                    />
                    <div class="generic-Card">
                      <div style="width: 100%">
                        <uploadfile
                          ref="answer"
                          v-model="data.image_url"
                          :height="ratio == 'square' ? 246 : 184.5"
                          data-vv-as="Image"
                          :data-vv-name="'answer_' + (index - 1) + '_image_' + index"
                          v-validate
                          :borderTopRightRadius="15"
                          :borderTopLeftRadius="15"
                          :ratio="ratio"
                          :changeRatio="true"
                          @onChangeRatio="onChangeRatio"
                        ></uploadfile>
                      </div>
                      <div style="display: flex; flex-direction: column; justify-content: center">
                        <input
                          v-model="data.title"
                          style="width: 220px; margin-top: 3px; margin-bottom: 3px"
                          class="input-focus"
                          placeholder="ใส่หัวข้อ"
                        />
                        <input
                          v-model="data.subtitle"
                          style="width: 220px; margin-bottom: 6px"
                          class="input-focus"
                          placeholder="ใส่หัวข้อ"
                        />
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            gap: 10px;
                            justify-content: center;
                            align-items: center;
                            padding: 0px 16px;
                          "
                        >
                          <template v-for="(item, idx) in data.buttons">
                            <div class="button-editButton">
                              <template v-if="genericEditButton[index][idx]">
                                <input
                                  v-model="item.title"
                                  class="input-focus"
                                  style="
                                    color: #fff;
                                    font-weight: 700;
                                    font-size: 16px;
                                    margin-left: 0;
                                  "
                                  maxlength="20"
                                />
                                <img
                                  src="/static/img/assets/welcome/correct-white.svg"
                                  style="width: 20px; height: 20px"
                                  @click="genericChangeEditButton(index, idx)"
                                />
                              </template>
                              <template v-else>
                                <div
                                  style="
                                    color: #ffffff;
                                    font-weight: 700;
                                    font-size: 16px;
                                    width: 100%;
                                  "
                                >
                                  {{ item.title }}
                                </div>

                                <img
                                  src="/static/img/assets/welcome/pencil-white.svg"
                                  style="width: 20px; height: 20px"
                                  @click="genericChangeEditButton(index, idx)"
                                />
                              </template>
                              <img
                                src="/static/img/assets/welcome/bin-white.svg"
                                style="width: 20px; height: 20px"
                                @click="genericDeleteButton(index, idx)"
                              />
                            </div>
                          </template>

                          <template v-if="data.buttons.length < 3">
                            <div class="button-addButton" @click="genericAddButton(index)">
                              <img
                                src="/static/img/assets/welcome/plus-gray.svg"
                                style="width: 20px; height: 20px"
                              />
                              <div style="color: #bdbdbd; font-weight: 700; font-size: 16px">
                                เพิ่มปุ่มกด
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </slide>
              </carousel>
              <div
                style="
                  margin-top: 20px;
                  display: flex;
                  justify-content: flex-end;
                  align-items: end;
                  gap: 8px;
                "
              >
                <div v-for="(data, index) in genericData">
                  <div
                    class="box"
                    :class="genericButtonIndex == index ? 'active' : ''"
                    @click="genericChangeCarousel(index)"
                  >
                    <div class="box-number" :class="genericButtonIndex == index ? 'active' : ''">
                      {{ index + 1 }}
                    </div>
                  </div>
                </div>
                <template v-if="this.genericData.length < 10">
                  <div
                    style="
                      width: 32px !important;
                      height: 32px !important;
                      border-radius: 5px !important;
                      background: #ffffff !important;
                      border: 1px solid #bdbdbd !important;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                    @click="genericAddContent()"
                  >
                    <div style="color: #bdbdbd; font-weight: 400; font-size: 14px">+</div>
                  </div>
                </template>
              </div>
            </div>

            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 4px;
                margin-top: 16px;
                width: 100%;
              "
            >
              <div
                v-if="genericData[this.genericButtonIndex].buttons.length > 0"
                style="display: flex; flex-direction: row; justify-content: flex-start; width: 100%"
              >
                <div style="font-weight: 600; font-size: 16px; color: #2c2c2c">ตั้งค่าปุ่มกด</div>
              </div>
              <template v-for="(data, index) in this.genericData[this.genericButtonIndex].buttons">
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    margin-top: 8px;
                    width: 100%;
                  "
                >
                  <div class="button-settingButtonTop">
                    {{ data.title }}
                  </div>
                  <div class="button-settingButtonBotton">
                    <div class="broadcast-button-module">
                      <v-select
                        v-model="data.type"
                        :items="buttonType"
                        item-text="name"
                        item-value="type"
                        hide-details
                        dense
                        outline
                        append-icon="mdi-chevron-down"
                      >
                        <template slot="selection" slot-scope="data">
                          <div style="display: flex; align-items: center; width: 100%">
                            <v-flex xs2>
                              <img :src="`/static/img/${data.item.icon}`" style="width: 20px" />
                            </v-flex>
                            <v-flex xs10>
                              <typography h5 color="color-mediumBlue" :label="data.item.name" />
                            </v-flex>
                          </div>
                        </template>
                        <template slot="item" slot-scope="data">
                          <v-flex xs2>
                            <img :src="`/static/img/${data.item.icon}`" style="width: 20px" />
                          </v-flex>
                          <v-flex xs10>
                            <typography h5 color="color-mediumBlue" :label="data.item.name" />
                          </v-flex>
                        </template>
                      </v-select>
                    </div>
                    <template v-if="data.type === 'web_url'">
                      <div style="font-weight: 500; font-size: 14px; color: #818181">
                        *หากลูกค้ากดปุ่มนี้ บอทจะพาลูกค้าไปสู่ลิ้งค์นี้
                      </div>
                      <div style="width: 100%">
                        <div style="color: #2c2c2c; font-weight: 600; font-size: 16px">ลิ้งค์</div>

                        <div class="input-border">
                          <input
                            v-model="data.url"
                            class="input-focus"
                            placeholder="http://www.example.com"
                          />
                        </div>
                      </div>
                    </template>
                    <template v-if="data.type === 'postback'">
                      <div style="font-weight: 500; font-size: 14px; color: #818181">
                        *หากลูกค้ากดปุ่มนี้ บอทจะตอบกลับลูกค้า (คุณสามารถแก้ไขคำตอบในหน้า
                        conversation)
                      </div>
                      <div>
                        <div style="color: #2c2c2c; font-weight: 600; font-size: 16px">Action</div>
                        <div class="input-border">
                          <input v-model="data.payload" class="input-focus" />
                        </div>
                      </div>
                    </template>
                    <template v-if="data.type === 'phone_number'">
                      <div style="font-weight: 500; font-size: 14px; color: #818181">
                        *หากลูกค้ากดปุ่มนี้ บอทจะโทรออกอัตโนมัติตามเบอร์ที่กรอกไว้
                        (ฟังก์ชันนี้ใช้ได้เมื่อลูกค้าใช้มือถือในการเชื่อมต่อเท่านั้น)
                      </div>
                      <div>
                        <div style="color: #2c2c2c; font-weight: 600; font-size: 16px">
                          เบอร์โทร
                        </div>
                        <div class="input-border">
                          <input
                            v-model="data.payload"
                            class="input-focus"
                            placeholder="+66000000000"
                          />
                        </div>
                      </div>
                    </template>
                    <template v-if="data.type === 'broadcast'">
                      <div class="type-radio">
                        <v-radio-group v-model="data.payload" row>
                          <v-radio
                            label="สมัครรับข่าวสาร"
                            value="subscribeBroadcast"
                            color="rgba(12, 47, 83, 1)"
                          ></v-radio>
                          <v-radio
                            label="ยกเลิกรับข่าวสาร"
                            value="unsubscribeBroadcast"
                            color="rgba(12, 47, 83, 1)"
                          ></v-radio>
                        </v-radio-group>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="hr-color" style="margin-top: 16px"></div>
          <div class="btn-footer">
            <Button
              width="142px"
              outline
              :label="$t('cancel')"
              @click="cancelModal(message.type)"
            />
            <Button width="142px" depressed :label="$t('Save')" @click="addMessage(message.type)" />
          </div>
        </div>
      </modal-notify>
    </template>

    <template v-if="this.message.type === 'flex'">
      <div class="flex">
        <img src="/static/img/assets/welcome/TypeFlexMessage.svg" />
        <typography h6 :label="$t('Flex Message')" :medium="true"></typography>
      </div>
      <div
        v-if="broadcastType === 'draft'"
        class="flex"
        style="justify-content: flex-end; gap: 0px"
      >
        <img
          class="EditIcon"
          @click="openModal(message.type)"
          src="/static/img/assets/welcome/edit.svg"
        />
        <img
          class="EditIcon"
          @click="toggleDeleteMessage"
          src="/static/img/assets/welcome/delete.svg"
        />
        <img class="DragIcon handle" src="/static/img/assets/welcome/Drag.svg" />
      </div>

      <modal-notify v-if="modalFlex" :isFixed="false" modalWidth="700px">
        <div slot="header">
          <div
            style="display: flex; flex-direction: row; justify-content: space-between; width: 100%"
          >
            <typography h2 :label="$t('แก้ไข Flex Message')" :bold="true"></typography>
            <img
              src="/static/img/assets/welcome/X.svg"
              class="close-icon"
              @click="cancelModal(message.type)"
            />
          </div>
        </div>
        <div slot="body">
          <div style="width: 100%; margin-top: 40px">
            {
            <br />
            <span class="pl-5">type: flex,</span>
            <br />
            <span class="pl-5">contents:</span>
            <br />
            <div class="pl-5">
              <codemirror ref="cmCode" v-model="flexContents" :options="cmOptions"></codemirror>
            </div>

            <br />
            }
            <br />
          </div>
        </div>
        <div slot="footer">
          <div class="hr-color" style="margin-top: 16px"></div>
          <div class="btn-footer">
            <Button
              width="142px"
              outline
              :label="$t('cancel')"
              @click="cancelModal(message.type)"
            />
            <Button width="142px" depressed :label="$t('Save')" @click="addMessage(message.type)" />
          </div>
        </div>
      </modal-notify>
    </template>

    <template v-if="this.message.type === 'sticker'">
      <div class="flex">
        <img src="/static/img/assets/welcome/TypeLineSticker.svg" />
        <typography h6 :label="$t('Line Sticker')" :medium="true"></typography>
      </div>
      <div
        v-if="broadcastType === 'draft'"
        class="flex"
        style="justify-content: flex-end; gap: 0px"
      >
        <img
          class="EditIcon"
          @click="openModal(message.type)"
          src="/static/img/assets/welcome/edit.svg"
        />
        <img
          class="EditIcon"
          @click="toggleDeleteMessage"
          src="/static/img/assets/welcome/delete.svg"
        />
        <img class="DragIcon handle" src="/static/img/assets/welcome/Drag.svg" />
      </div>
      <modal-notify v-if="modalSticker" :isFixed="true" modalWidth="600px">
        <div slot="header">
          <div
            style="display: flex; flex-direction: row; justify-content: space-between; width: 100%"
          >
            <typography h2 :label="$t('แก้ไข Sticker')" :bold="true"></typography>
            <img
              src="/static/img/assets/welcome/X.svg"
              class="close-icon"
              @click="cancelModal(message.type)"
            />
          </div>
        </div>
        <div slot="body">
          <div style="width: 100%; margin-top: 40px">
            <div>
              <v-divider></v-divider>
              <v-layout>
                <template v-for="(sticker, index) in stickers">
                  <v-flex
                    style="max-width: 50px; border-right: 1px solid #eee"
                    :class="{ primary: currentPackage == index }"
                    @click="currentPackage = index"
                  >
                    <div class="py-1 px-2">
                      <v-img
                        aspect-ratio="1"
                        :src="`/static/img/assets/stickers/${index}/${sticker[0]}.png`"
                        style="height: 30px; width: 30px"
                      ></v-img>
                    </div>
                  </v-flex>
                </template>
              </v-layout>
              <v-divider></v-divider>
            </div>
            <v-card-text style="max-height: 600px">
              <v-layout wrap>
                <v-flex
                  xs3
                  sm2
                  class="pa-1 sticker"
                  v-for="(sticker, index) in stickers[currentPackage]"
                  :key="`sticker_${index}`"
                  style="cursor: pointer"
                  @click="addSticker(currentPackage, sticker)"
                >
                  <v-img
                    aspect-ratio="1"
                    :src="`/static/img/assets/stickers/${currentPackage}/${sticker}.png`"
                    style=""
                  ></v-img>
                </v-flex>
              </v-layout>
            </v-card-text>
          </div>
        </div>
      </modal-notify>
    </template>
    <modal-notify v-if="modalDelete" :isFixed="true" modalWidth="400px">
      <div slot="header">
        <div style="display: flex; flex-direction: row; justify-content: end; width: 100%">
          <img
            src="/static/img/assets/welcome/X.svg"
            class="close-icon"
            @click="toggleDeleteMessage"
          />
        </div>
      </div>
      <div slot="body">
        <div style="display: flex; flex-direction: column; align-items: center; gap: 24px">
          <img src="/static/img/assets/welcome/delete.svg" style="width: 63px; height: 63px" />
          <div style="font-weight: 700; font-size: 16px; color: #0c2f53">
            คุณต้องการลบโมดูลนี้ใช่หรือไม่
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="hr-color" style="margin-top: 16px"></div>
        <div class="btn-footer">
          <Button width="142px" outline :label="$t('cancel')" @click="toggleDeleteMessage()" />
          <Button width="142px" depressed :label="$t('Save')" @click="summitDelateMessage()" />
        </div>
      </div>
    </modal-notify>
  </div>
</template>
<script>
import Typography from '../../elements/Typography.vue'
import Button from '../../elements/Button.vue'
import api from '@/api'
import uploadfile from '@/components/elements/uploadfile'
import uploadVideo from '@/components/elements/uploadvideo'
import { Carousel, Slide } from 'vue-carousel'
import { codemirror } from 'vue-codemirror'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import ModalNotify from '@/components/elements/ModalNotify'

export default {
  components: {
    Typography,
    Button,
    uploadfile,
    uploadVideo,
    Carousel,
    Slide,
    codemirror,
    DropdownMenu,
    ModalNotify,
  },
  data: function () {
    return {
      nextLabel: "<img src='/static/img/arrow_next.png' style='width: 25px; height: 25px'/>",
      prevLabel: "<img src='/static/img/arrow_back.png' style='width: 25px; height: 25px'/>",
      modalDelete: false,
      bubbleMessages: [],
      messages: [],
      modalText: false,
      textTitle: '',
      textRecommend: [
        {
          value: '{first_name}',
          title: 'ชื่อจริง',
        },
        {
          value: '{last_name}',
          title: 'นามสกุล',
        },
        {
          value: '{status}',
          title: 'สถานะ',
        },
        {
          value: '{tag}',
          title: 'ป้ายกำกับ',
        },
        {
          value: '{msg}',
          title: 'ข้อความ',
        },
        {
          value: '{session.default={msg}}',
          title: 'เซสชั่น',
        },
      ],
      modalButton: false,
      buttonTitle: '',
      buttonEditButton: [false],
      buttonButton: [
        {
          title: 'ชื่อปุ่ม',
          type: 'web_url',
          url: '',
          payload: '',
        },
      ],
      buttonType: [
        { name: 'ลิ้งค์', type: 'web_url', icon: 'SelectLink.png' },
        { name: 'ข้อความ', type: 'postback', icon: 'SelectMessage.png' },
        { name: 'เบอร์โทร', type: 'phone_number', icon: 'SelectPhone.png' },
        { name: 'บรอดแคสต์', type: 'broadcast', icon: 'SelectBroadcast.png' },
      ],
      buttonBroadcastType: [
        { name: 'สมัครรับข่าวสาร', type: 'subscribeBroadcast' },
        { name: 'ยกเลิกรับข่าวสาร', type: 'unsubscribeBroadcast' },
      ],
      modalImage: false,
      image_url: '',
      modalVideo: false,
      videoType: 'upload',
      upload_url: '',
      video_url: '',
      videoCheckType: [
        { name: 'อัปโหลดวีดิโอ', type: 'upload' },
        { name: 'แนบลิ้งค์ URL', type: 'link_url' },
      ],
      ratio: 'square',
      modalGeneric: false,
      genericData: [
        {
          image_url: '',
          title: '',
          subtitle: '',
          buttons: [
            {
              title: 'ชื่อปุ่ม',
              type: 'web_url',
              url: '',
              payload: '',
            },
          ],
          default_action: {
            type: 'web_url',
            url: '',
          },
        },
      ],
      genericEditButton: [[false]],
      genericButtonIndex: 0,

      modalFlex: false,
      flexContents: '',
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true,
        },
        showCursorWhenSelecting: true,
        matchBrackets: true,
        styleSelectedText: true,
        styleActiveLine: true,
        theme: 'base16-light',
        lineNumbers: true,
        line: true,
        autoFocus: true,
        autoRefresh: true,
        // more codemirror options, 更多 codemirror 的高级配置...
      },
      modalSticker: false,
      packageid: '',
      stickerid: '',
      currentPackage: 11537,
      stickers: {
        11537: [
          52002734, 52002735, 52002736, 52002737, 52002738, 52002739, 52002740, 52002741, 52002742,
          52002743, 52002744, 52002745, 52002746, 52002747, 52002748, 52002749, 52002750, 52002751,
          52002752, 52002753, 52002754, 52002755, 52002756, 52002757, 52002758, 52002759, 52002760,
          52002761, 52002762, 52002763, 52002764, 52002765, 52002766, 52002767, 52002768, 52002769,
          52002770, 52002771, 52002772, 52002773,
        ],
        11538: [
          51626497, 51626494, 51626495, 51626496, 51626498, 51626499, 51626500, 51626501, 51626502,
          51626503, 51626504, 51626505, 51626506, 51626507, 51626508, 51626509, 51626510, 51626511,
          51626512, 51626513, 51626514, 51626515, 51626516, 51626517, 51626518, 51626519, 51626520,
          51626521, 51626522, 51626523, 51626524, 51626525, 51626526, 51626527, 51626528, 51626529,
          51626530, 51626531, 51626532, 51626533,
        ],
        11539: [
          52114113, 52114110, 52114111, 52114112, 52114114, 52114115, 52114116, 52114117, 52114118,
          52114119, 52114120, 52114121, 52114122, 52114123, 52114124, 52114125, 52114126, 52114127,
          52114128, 52114129, 52114130, 52114131, 52114132, 52114133, 52114134, 52114135, 52114136,
          52114137, 52114138, 52114139, 52114140, 52114141, 52114142, 52114143, 52114144, 52114145,
          52114146, 52114147, 52114148, 52114149,
        ],
      },
    }
  },
  props: {
    message: Object,
    keyIndex: Number,
    intent_index: Number, //index ที่เลือกอยู่
    answers: Array,
    type: String,
    value: Array,
    broadcastType: String,
  },
  mounted: function () {
    if (this.message.type === 'text') {
      this.textTitle = this.message.text
    } else if (this.message.type === 'button') {
      this.buttonTitle = this.message.text
      this.buttonButton = this.message.buttons
    } else if (this.message.type === 'image') {
      this.image_url = this.message.image_url
    } else if (this.message.type === 'video') {
    } else if (this.message.type === 'generic') {
      this.genericData = this.message.data
      this.genericEditButton = this.message.data.map((item) => {
        return [false]
      })
      this.radio = this.message.radio
    } else if (this.message.type === 'flex') {
      this.flexContents = this.message.contents
    } else if (this.message.type === 'sticker') {
    }
  },
  methods: {
    onChangeRatio: function () {
      if (this.ratio == 'square') {
        this.ratio = 'horizontal'
      } else {
        this.ratio = 'square'
      }
    },
    openModal: function (type) {
      if (type === 'text') {
        this.modalText = true
        this.textTitle = this.message.text
      } else if (type === 'button') {
        this.modalButton = true
        this.buttonTitle = this.message.text
        this.buttonButton = this.message.buttons
      } else if (type === 'image') {
        this.modalImage = true
        this.image_url = this.message.image_url
      } else if (type === 'video') {
        let type = this.message.source.indexOf('//api') != -1 ? 'upload' : 'link_url'
        this.modalVideo = true
        this.videoType = type
        if (type === 'upload') {
          this.upload_url = this.message.source || this.message.sourceline
        } else {
          this.video_url = this.message.source || this.message.sourceline
        }
      } else if (type === 'generic') {
        this.modalGeneric = true
        this.genericData = this.message.data
        this.genericEditButton = this.message.data.map((item) => {
          return [false]
        })
      } else if (type === 'flex') {
        this.modalFlex = true
        this.flexContents = this.message.contents
      } else if (type === 'sticker') {
        this.modalSticker = true
      }
    },
    closeModal: function (type, index) {
      if (type === 'text') {
        this.modalText = false
        this.textTitle = this.value[index].text
      } else if (type === 'button') {
        this.modalButton = false
        this.buttonTitle = this.value[index].text
        this.buttonButton = this.value[index].buttons
      } else if (type === 'image') {
        this.modalImage = false
        this.image_url = this.value[index].image_url
      } else if (type === 'video') {
        this.modalVideo = false
        let type = this.value[index].source.indexOf('//api') != -1 ? 'upload' : 'link_url'
        this.videoType = type
        if (type === 'upload') {
          this.upload_url = this.value[index].source || this.value[index].sourceline
        } else {
          this.video_url = this.value[index].source || this.value[index].sourceline
        }
      } else if (type === 'generic') {
        this.modalGeneric = false
        this.genericData = this.value[index].data
        this.genericEditButton = this.value[index].data.map((item) => {
          return [false]
        })
        this.radio = this.value[index].radio
      } else if (type === 'flex') {
        this.modalFlex = false
        this.flexContents = this.value[index].contents
      } else if (type === 'sticker') {
        this.modalSticker = false
      }
    },
    cancelModal: function (type) {
      if (type === 'text') {
        this.modalText = false
        this.textTitle = this.message.text
      } else if (type === 'button') {
        this.modalButton = false
        this.buttonTitle = this.message.text
        this.buttonButton = this.message.buttons
      } else if (type === 'image') {
        this.modalImage = false
        this.image_url = this.message.image_url
      } else if (type === 'video') {
        this.modalVideo = false
        let type = this.message.source.indexOf('//api') != -1 ? 'upload' : 'link_url'
        this.videoType = type
        if (type === 'upload') {
          this.upload_url = this.message.source || this.message.sourceline
        } else {
          this.video_url = this.message.source || this.message.sourceline
        }
      } else if (type === 'generic') {
        this.modalGeneric = false
        this.genericData = this.message.data
        this.genericEditButton = this.message.data.map((item) => {
          return [false]
        })
        this.radio = this.message.radio
      } else if (type === 'flex') {
        this.modalFlex = false
        this.flexContents = this.message.contents
      } else if (type === 'sticker') {
        this.modalSticker = false
      }
    },
    addIntentItem: function (type, data) {
      let vm = this
      if (type == 'text') {
        this.value.splice(this.keyIndex, 1, {
          text: this.textTitle,
          type: type,
        })
      } else if (type == 'button') {
        const newButton = []
        this.buttonButton.map((item) => {
          if (item.type === 'web_url') {
            delete item.payload
          } else {
            delete item.url
          }
          newButton.push(item)
        })
        this.value.splice(this.keyIndex, 1, {
          text: this.buttonTitle,
          buttons: newButton,
          type: type,
        })
      } else if (type == 'image') {
        this.value.splice(this.keyIndex, 1, {
          image_url: this.image_url,
          type: type,
        })
      } else if (type == 'video') {
        this.value.splice(this.keyIndex, 1, {
          type: type,
          source: this.upload_url || this.video_url,
          picture: null,
          sourceline: this.upload_url || this.video_url,
        })
      } else if (type == 'generic') {
        this.genericData.map((item) => {
          item.buttons.map((button) => {
            if (button.type === 'web_url') {
              delete button.payload
            } else {
              delete button.url
            }
          })
        })
        this.value.splice(this.keyIndex, 1, {
          data: this.genericData,
          type: type,
        })
      } else if (type === 'flex') {
        this.value.splice(this.keyIndex, 1, {
          type: type,
          altText: 'You received a message',
          contents: this.flexContents,
        })
      } else if (type === 'sticker') {
        this.value.splice(this.keyIndex, 1, {
          type: type,
          packageid: this.packageid,
          stickerid: this.stickerid,
        })
      }
      vm.$emit('input', vm.value)
    },
    saveWelcomeMessage: function () {
      let vm = this
      let data = {
        pageid: vm.$store.state.selectedBot.pageid,
        type: 'json',
      }

      var messages = []

      //data['message'] = `[[{\"text\":\"one1\",\"type\":\"text\"},{\"text\":\"one2\",\"type\":\"text\"}],[{\"text\":\"two1\",\"type\":\"text\"},{\"text\":\"two2\",\"type\":\"text\"}],[{\"text\":\"three1\",\"type\":\"text\"},{\"text\":\"three2\",\"type\":\"text\"}]]`
      data['message'] = JSON.stringify(this.answers)
      vm.$store.dispatch('loading')

      vm.$emit('onSaveMessage')
      this.closeModal(this.type, this.keyIndex)
    },

    async addMessage() {
      if (this.answers[this.intent_index].length > 5) {
        this.$swal.fire({
          title: '<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
          html: `<div> ไม่สามารถใช้เครื่องหมายจุลภาค (,) ในประโยคได้ กรุณาลองใหม่อีกครั้ง </div>`,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
          width: '590px',
        })
        return
      }

      this.addIntentItem(this.type)
      this.saveWelcomeMessage()
    },
    async isValid() {
      let isValid = await this.$validator.validate()
      if (isValid) {
        return
      }
    },
    textAddRecommend: function (value) {
      this.textTitle = this.textTitle + value
    },
    buttonAddButton: function () {
      this.buttonButton.push({
        title: 'ปุ่ม',
        type: 'web_url',
        url: '',
      })
      this.buttonEditButton.push(false)
    },
    buttonDeleteButton: function (index) {
      this.buttonButton.splice(index, 1)
      this.buttonEditButton.splice(index, 1)
    },
    buttonChangeEditButton: function (index) {
      this.buttonEditButton[index] = !this.buttonEditButton[index]
      this.$forceUpdate()
    },
    genericAddContent: function () {
      this.genericData.push({
        image_url: '',
        title: '',
        subtitle: '',
        buttons: [
          {
            title: 'ชื่อปุ่ม',
            type: 'web_url',
            url: '',
            payload: '',
          },
        ],
        default_action: {
          type: 'web_url',
          url: '',
        },
      })
      this.genericEditButton.push([false])
    },
    genericDeleteContent: function (index) {
      let newGeneric = this.genericData.filter((item, idx) => idx !== index)
      this.genericData = newGeneric
      this.$forceUpdate()
    },

    genericAddButton: function (index) {
      this.genericData[index].buttons.push({
        title: 'ชื่อปุ่ม',
        type: 'web_url',
        url: '',
        payload: '',
      })
      this.genericEditButton[index].push(false)
    },
    genericDeleteButton: function (index, idx) {
      this.genericData[index].buttons.splice(idx, 1)
      this.genericEditButton[index].splice(idx, 1)
    },
    genericChangeEditButton: function (index, idx) {
      this.genericEditButton[index][idx] = !this.genericEditButton[index][idx]

      this.$forceUpdate()
    },
    genericChangeCarousel: function (index) {
      this.genericButtonIndex = index
    },
    async addSticker(packageid, stickerid) {
      var result = await this.$swal.fire({
        title: `<img src="/static/img/assets/stickers/${packageid}/${stickerid}.png" style="max-height: 150px">`,
        text: this.$t('Do you want to send this sticker?'),
        showCancelButton: true,
        confirmButtonText: '<span style="color:#FFEF01">ยืนยัน</span>',
        cancelButtonText: '<span style="color: #0C2F53;">ยกเลิก</span>',
        reverseButtons: true,
      })
      if (result.value) {
        this.packageid = packageid
        this.stickerid = stickerid
        this.addMessage()
      }
    },
    toggleDeleteMessage: function () {
      this.modalDelete = !this.modalDelete
    },
    summitDelateMessage: function () {
      let vm = this
      this.value.splice(this.keyIndex, 1)
      this.saveWelcomeMessage()
      vm.$emit('input', vm.value)
      this.modalDelete = false
    },
  },
}
</script>
<style lang="scss" scoped>
.box-layout {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 12px;
  width: 241px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #0c2f53;
  border-radius: 10px;
}
.flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}
.EditIcon {
  width: 22px;
  height: 22px;
  cursor: pointer;
}
.DragIcon {
  width: 22px;
  height: 22px;
  cursor: move;
}
.box {
  width: 32px !important;
  height: 32px !important;
  border-radius: 5px !important;
  /* background: #FFFFFF !important; */
  border: 1px solid #0c2f53 !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-addChatbot {
  width: 100px !important;
  height: 80px !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  border: 1px solid #0c2f53 !important;
  padding-top: 12px;
  cursor: default;
}
.box-addChatbot:hover {
  width: 100px !important;
  height: 80px !important;
  border-radius: 10px !important;
  background: rgba(230, 240, 251, 1) !important;
  border: 1px solid #0c2f53 !important;
  padding-top: 12px;
}
.box-addChatbot-disable {
  width: 100px !important;
  height: 80px !important;
  background: #ffffff !important;
  padding-top: 12px !important;
  border: 1px dashed #0c2f53 !important;
  border-radius: 10px !important;
  cursor: default;
  opacity: 0.5;
}

.flex-addChatbot {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.modal {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 30px 26px 30px 26px;
  position: fixed;
  top: 40px;
  overflow-x: hidden;
  border-radius: 10px;
}

.v-overlay--active {
  backdrop-filter: blur(2px) !important;
  background: rgba(0, 0, 0, 0.87) !important;
  opacity: 1 !important;
}
.v-overlay::before {
  opacity: 1 !important;
}
.btn-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 14px;
}
.btn-summit {
  background: #0c2f53 !important;
  border-radius: 6px;
  width: 142px;
  height: 38px;
  color: #ffef01;
  font-weight: 700;
  font-size: 16px;
}
.btn-cancel {
  background: #ffffff !important;
  border: 1px solid #0c2f53;
  border-radius: 6px;
  width: 142px;
  height: 38px;
  color: #0c2f53;
  font-weight: 700;
  font-size: 16px;
}
.tag-box {
  /* background-color: red; */
  background-color: #fff;
  padding: 0px 8px 0px 8px;
  display: inline-block;
  margin-right: 8px;
  /* margin-bottom: 8px; */
  border: 1px solid rgba(12, 47, 83, 1);
  color: #fff;
  border-radius: 6px;
  min-width: 60px;
  text-align: center;
  justify-content: center;
  height: 25px;
  cursor: default;
}
.tag-box:hover {
  background-color: rgba(230, 240, 251, 1);
}
.close-icon {
  position: relative;
  top: -10px;
  right: -10px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.text-area-focus {
  border: 1px solid #0c2f53;
  border-radius: 10px;
  color: #0c2f53;
  size: 16px;
  font-weight: 400;
}
.text-area-focus:focus-visible {
  outline: none;
}
.flex-text-area {
  border: 1px solid #9e9e9e;
}
.text-error {
  color: red;
}

.input-border {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  border: 1px solid #0c2f53;
  border-radius: 6px;
  height: 40px;
  width: 100%;
  background-color: white;
}
.input-focus {
  border-bottom: 0px solid #9e9e9e;
  border: none !important;
  outline: none;
  margin: 0px;
  font-family: 'Sukhumvit' !important;
  height: 38px;
  margin-left: 14px;
  margin-bottom: 0px;
}
.input-focus:focus {
  border-bottom: 0px solid #9e9e9e;
  border: none !important;
  outline: none;
  box-shadow: 0 0px 0 0 #000 !important;
}
.button-editButton {
  cursor: pointer;
  background: linear-gradient(274.72deg, #0c2f53 7.12%, #26588b 99.76%);
  border-radius: 5px;
  width: 188px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 16px;
  padding-right: 16px;
}
.button-addButton {
  display: flex;
  cursor: pointer;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: 1px dashed #bdbdbd;
  border-radius: 5px;
  width: 188px;
  height: 40px;
}
.button-settingButtonTop {
  background: linear-gradient(274.72deg, #0c2f53 7.12%, #26588b 99.76%);
  border-radius: 8px 8px 0px 0px;
  width: 100%;
  height: 40px;
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  padding-left: 26px;
  display: flex;
  align-items: center;
}
.button-settingButtonBotton {
  background: #e6f0fb;
  border-radius: 0px 0px 8px 8px;
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.button-settingButtonBotton > div.type-radio > div {
  margin: 0px;
  padding: 0px;
}
.broadcast-button-module > div {
  display: flex;
  background: #ffffff;
  border: 1px solid #2c2c2c !important;
  border-radius: 6px !important;
  outline: none;
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.button-inputButtonType {
  height: 37px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #0c2f53;
  border-radius: 6px;
  padding: 0px 14px;
  color: #0c2f53;
  outline: none;
  box-shadow: none !important;
}
.generic-Card {
  width: 246px;
  min-height: 363px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 0px;
  margin-top: 10px;
  padding-bottom: 10px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  box-shadow: 4px 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
}
.carousel-card {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/view/broadcast/ChatbotBox.vue